<div>
  <mat-form-field class="full-width">
    <mat-label>{{ this.placeHolder | translate}}</mat-label>
  <input matInput [ngClass]="{ 'one': editMode}" value="{{this.itemName}}" [disabled]="true">
    <i matSuffix class="glyphicon glyphicon-new-window link" (click)="showDropDownSelectorModal()" *ngIf="editMode"></i>
</mat-form-field>
</div>